import { Injectable, ErrorHandler, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { DataService } from "./data.service";
import { UntypedFormControl } from "@angular/forms";
import { AuthService } from "./auth.service";
import { environment } from "../environments/environment";
import moment from "moment";
import * as StackTrace from "stacktrace-js";

@Injectable()
export class ErrorHandlerService implements ErrorHandler {
  _dataService = inject(DataService);
  _authService = inject(AuthService);
  http = inject(HttpClient);

  handleError(error: any): void {
    console.log("HANDLER: ", error);
    if (environment.production && navigator.onLine) {
      StackTrace.fromError(error).then((stackframes) => {
        const stackString = stackframes.map((sf) => sf.toString()).join("\n");

        this.http
          .post("https://tekoplast.az/hesabat/api/?error", {
            message: error?.message ?? "",
            stackTrace: stackString ?? "",
            transaction: error?.name ?? "",
            data: JSON.stringify(error) ?? "",
            formData: JSON.stringify(error?.headers) ?? "",
            date:
              new UntypedFormControl(moment()).value.format(
                "YYYY-MM-DD HH:mm:ss"
              ) ?? "",
            dbTable: this._dataService.dbTable ?? "",
            user: this._authService?.loggedInUserValue?.fullname ?? "",
            appVersion: environment.production ? environment.version : "dev",
          })
          .subscribe({
            complete: () => {
              console.log("Error sent to backend successfully.");
            },
            error: (apiError) => {
              console.error("Failed to send error to backend:", apiError);
            },
          });
      });
    }
  }
}
